<table #tcmVar="tcmVar"
       [tcmVar]="{address1Exists: !!(this.address1Line1 || this.address1Line2 || this.city1 || this.state1 || this.country1 || this.zip1 || isPermanentRequired),
                  address2Exists: !!(this.address2Line1 || this.address2Line2 || this.city2 || this.state2 || this.country2 || this.zip2 || isPermanentRequired)}"
       class="address-table"
       [ngClass]="{disabled: disabled, showOnly1Address: showOnly1Address, showIsPrimaryColumn: showIsPrimaryColumn}">
  <thead>
    <tr>
      <th width="15%"
          [class.required]="(tcmVar.var.address1Exists || tcmVar.var.address2Exists) && isCountryRequired">
        {{ (countryTitleKey || 'Common.SearchColumnsAndDetailsFields.Country')  | translate }}
      </th>
      <th width="20%" *ngIf="!showOnlyCountryState"
          [class.required]="(tcmVar.var.address1Exists || tcmVar.var.address2Exists) && isAddressLine1Required">
        {{ (addressLine1TitleKey || 'Common.SearchColumnsAndDetailsFields.Address1')  | translate }}
      </th>
      <th width="20%" *ngIf="!showOnlyCountryState"
          [class.required]="(tcmVar.var.address1Exists || tcmVar.var.address2Exists) && isAddressLine2Required">
        {{ (addressLine2TitleKey || 'Common.SearchColumnsAndDetailsFields.Address2')  | translate }}
      </th>
      <th width="15%" *ngIf="!showOnlyCountryState"
          [class.required]="(tcmVar.var.address1Exists || tcmVar.var.address2Exists) && isCityRequired">
        {{ (cityTitleKey || 'Common.SearchColumnsAndDetailsFields.City')  | translate }}
      </th>
      <th width="15%"
          [class.required]="(tcmVar.var.address1Exists || tcmVar.var.address2Exists) && isStateRequired">
        <span state-label [country]="country1 || country2"></span>
      </th>
      <th width="8%" *ngIf="!showOnlyCountryState"
          [class.required]="(tcmVar.var.address1Exists || tcmVar.var.address2Exists) && isZipRequired">
        {{ (zipTitleKey || 'Common.SearchColumnsAndDetailsFields.Zip')  | translate }}
      </th>
      <th width="7%" class="align-center" *ngIf="!showOnlyCountryState && !showOnly1Address && showIsPrimaryColumn">
        {{ (isPrimaryTitleKey || 'Screens.Patients.Details.Address.Primary')  | translate }}
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <ng-template [ngIf]="countryOptions" [ngIfElse]="country1TextInput">
          <waf-select-input name="{{hostName + '-country1'}}"
                            [ngModel]="country1"
                            (ngModelChange)="onCountry1Changed($event)"
                            [options]="countryOptions"
                            [allowClear]="true"
                            [required]="tcmVar.var.address1Exists && isCountryRequired"
                            [isReadonlyValue]="disabled"></waf-select-input>
        </ng-template>
        <ng-template #country1TextInput>
          <waf-text-input name="{{hostName + '-country1'}}"
                          [ngModel]="country1"
                          (ngModelChange)="onCountry1Changed($event)"
                          [required]="tcmVar.var.address1Exists && isCountryRequired"
                          [isReadonlyValue]="disabled"
                          [maxLength]="3"></waf-text-input>
        </ng-template>
      </td>
      <td *ngIf="!showOnlyCountryState">
        <tcm-address-autocomplete name="{{hostName + '-address1Line1'}}"
                                  [ngModel]="address1Line1"
                                  (ngModelChange)="onAddress1Line1Changed($event)"
                                  (addressSelect)="onAddress1Selected($event)"
                                  [searchInAllCountries]="searchInAllCountries"
                                  [required]="tcmVar.var.address1Exists && isAddressLine1Required"
                                  [isReadonlyValue]="disabled"
                                  [maxLength]="255">
          <map-viewer [addressComponents]="[address1Line1, address1Line2, city1, state1, country1]" after>
          </map-viewer>
        </tcm-address-autocomplete>
      </td>
      <td *ngIf="!showOnlyCountryState">
        <waf-text-input name="{{hostName + '-address1Line2'}}"
                        [ngModel]="address1Line2"
                        (ngModelChange)="onAddress1Line2Changed($event)"
                        [required]="tcmVar.var.address1Exists && isAddressLine2Required"
                        [isReadonlyValue]="disabled"
                        [maxLength]="255"></waf-text-input>
      </td>
      <td *ngIf="!showOnlyCountryState">
        <waf-text-input name="{{hostName + '-city1'}}"
                        [ngModel]="city1"
                        (ngModelChange)="onCity1Changed($event)"
                        [required]="tcmVar.var.address1Exists && isCityRequired"
                        [isReadonlyValue]="disabled"
                        [maxLength]="40"></waf-text-input>
      </td>

      <td>
        <waf-select-input name="{{hostName + '-state1'}}"
                          [ngModel]="state1"
                          (ngModelChange)="onState1Changed($event)"
                          [options]="state1Options"
                          [allowClear]="!isStateRequired"
                          [required]="tcmVar.var.address1Exists && isStateRequired"
                          [isReadonlyValue]="disabled"></waf-select-input>
      </td>
      <td *ngIf="!showOnlyCountryState">
        <waf-text-input name="{{hostName + '-zip1'}}"
                        [ngModel]="zip1"
                        (ngModelChange)="onZip1Changed($event)"
                        [required]="tcmVar.var.address1Exists && isZipRequired"
                        [isReadonlyValue]="disabled"
                        [maxLength]="10"></waf-text-input>
      </td>
      <td class="text-center" *ngIf="!showOnlyCountryState && !showOnly1Address && showIsPrimaryColumn">
        <waf-boolean-input name="{{hostName + '-isAddress1Primary'}}"
                           [ngModel]="isAddress1Primary"
                           (ngModelChange)="onIsAddress1PrimaryChecked($event)"
                           [isReadonlyValue]="disabled"></waf-boolean-input>
      </td>
    </tr>
    <tr *ngIf="!showOnly1Address">
      <td>
        <ng-template [ngIf]="countryOptions" [ngIfElse]="country2TextInput">
          <waf-select-input name="{{hostName + '-country2'}}"
                            [ngModel]="country2"
                            (ngModelChange)="onCountry2Changed($event)"
                            [options]="countryOptions"
                            [allowClear]="true"
                            [required]="tcmVar.var.address2Exists && isCountryRequired"
                            [isReadonlyValue]="disabled"></waf-select-input>
        </ng-template>
        <ng-template #country2TextInput>
          <waf-text-input name="{{hostName + '-country2'}}"
                          [ngModel]="country2"
                          (ngModelChange)="onCountry2Changed($event)"
                          [required]="tcmVar.var.address2Exists && isCountryRequired"
                          [isReadonlyValue]="disabled"
                          [maxLength]="3"></waf-text-input>
        </ng-template>
      </td>
      <td>
        <tcm-address-autocomplete name="{{hostName + '-address2Line1'}}"
                                  [ngModel]="address2Line1"
                                  (ngModelChange)="onAddress2Line1Changed($event)"
                                  (addressSelect)="onAddress2Selected($event)"
                                  [required]="tcmVar.var.address2Exists && isAddressLine1Required"
                                  [isReadonlyValue]="disabled"
                                  [maxLength]="255">
          <map-viewer [addressComponents]="[address2Line1, address2Line2, city2, state2, country2]" after>
          </map-viewer>
        </tcm-address-autocomplete>
      </td>
      <td>
        <waf-text-input name="{{hostName + '-address2Line2'}}"
                        [ngModel]="address2Line2"
                        (ngModelChange)="onAddress2Line2Changed($event)"
                        [required]="tcmVar.var.address2Exists && isAddressLine2Required"
                        [isReadonlyValue]="disabled"
                        [maxLength]="255"></waf-text-input>
      </td>
      <td>
        <waf-text-input name="{{hostName + '-city2'}}"
                        [ngModel]="city2"
                        (ngModelChange)="onCity2Changed($event)"
                        [required]="tcmVar.var.address2Exists && isCityRequired"
                        [isReadonlyValue]="disabled"
                        [maxLength]="40"></waf-text-input>
      </td>
      <td>
        <waf-select-input name="{{hostName + '-state2'}}"
                          [ngModel]="state2"
                          (ngModelChange)="onState2Changed($event)"
                          [options]="state2Options"
                          [allowClear]="!isStateRequired"
                          [required]="tcmVar.var.address2Exists && isStateRequired"
                          [isReadonlyValue]="disabled"></waf-select-input>
      </td>
      <td>
        <waf-text-input name="{{hostName + '-zip2'}}"
                        [ngModel]="zip2"
                        (ngModelChange)="onZip2Changed($event)"
                        [required]="tcmVar.var.address2Exists && isZipRequired"
                        [isReadonlyValue]="disabled"
                        [maxLength]="10"></waf-text-input>
      </td>
      <td class="text-center" *ngIf="showIsPrimaryColumn">
        <waf-boolean-input name="{{hostName + '-isAddress2Primary'}}"
                           [ngModel]="isAddress2Primary"
                           (ngModelChange)="onIsAddress2PrimaryChecked($event)"
                           [isReadonlyValue]="disabled"></waf-boolean-input>
      </td>
    </tr>
  </tbody>
</table>
<ng-container *ngIf="enableGooglePlaceId" >
  <hr />
  <table>
    <thead>
      <tr>
        <th width="35%">{{ (latitudeTitleKey || 'Common.SearchColumnsAndDetailsFields.Latitude')  | translate }}</th>
        <th width="35%">{{ (longitudeTitleKey || 'Common.SearchColumnsAndDetailsFields.Longitude')  | translate }}</th>
        <th width="30%">{{ (googlePlaceIdTitleKey || 'Common.SearchColumnsAndDetailsFields.GooglePlaceId')  | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <waf-number-input name="{{hostName + '-latitude'}}"
                          [ngModel]="latitude"
                          (ngModelChange)="onLatitudeChanged($event)"
                          [isReadonlyValue]="disabled"
                          [geoCoordinateValidator]="{type:'lat'}"
                          [allowDecimal]="true"
                          [allowNegative]="true"
                          [decimalLimit]="6"
                          ></waf-number-input>
        </td>
        <td>
          <waf-number-input name="{{hostName + '-longitude'}}"
                          [ngModel]="longitude"
                          (ngModelChange)="onLongitudeChanged($event)"
                          [isReadonlyValue]="disabled"
                          [geoCoordinateValidator]="{type:'long'}"
                          [allowDecimal]="true"
                          [allowNegative]="true"
                          [decimalLimit]="6"
                          ></waf-number-input>
        </td>
        <td>
          <waf-text-input name="{{hostName + '-googlePlaceId'}}"
                          [ngModel]="googlePlaceId"
                          (ngModelChange)="onGooglePlaceIdChanged($event)"
                          [isReadonlyValue]="disabled"
                          ></waf-text-input>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>